import { useLocation, useNavigate } from 'react-router-dom';
import { DA_TO_EN } from '@/components/en/EnLangSwitch';

/**
 * Language pill for the Danish site header — switches DA -> EN.
 * Maps the current Danish path to its English counterpart (falls back to /en).
 */
export default function DaToEnLangSwitch({ className = '' }) {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.replace(/\/$/, '').toLowerCase() || '/';
  const enTarget = DA_TO_EN[currentPath] || '/en';
  const productSku = { '/zaptec-go': 'zaptec_go', '/zaptec-go-2': 'zaptec_go_2', '/nexblue-edge-2': 'nexblue_edge_2' }[currentPath];
  const query = new URLSearchParams(window.location.search);
  if (productSku) { query.set('charger', productSku); query.set('situation', 'buy'); query.set('modal', 'specs'); }
  const destination = enTarget + (query.size ? `?${query}` : '') + (location.hash === '#aftaler' ? '#plans' : location.hash);

  return (
    <div className={`inline-flex items-center rounded-full border overflow-hidden text-xs font-semibold border-[#263A43]/15 text-[#21343D] hover:border-[#5E7B8C]/40 ${className}`}>
      <span className="px-2.5 py-1.5 bg-[#D4A62A]/15 text-[#7A5A08]">DA</span>
      <button
        onClick={() => { try { localStorage.setItem('enkel_lang_pref', 'en'); } catch {} navigate(destination); }}
        className="px-2.5 py-1.5 hover:bg-[#F1EBDD] transition-colors"
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  );
}